import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { PlanningPortalGlobalState } from "../../../state/planning-portal-global-state/planning-portal-global.state";
import { Observable } from "rxjs";

@Injectable()
export class HttpDistributionLaneInterceptor implements HttpInterceptor {
    
  constructor(private store: Store) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

     if (req.url.includes('/api/Account/Login')) {
      return next.handle(req);
    }
    const selectedDistributionLane = this.store.selectSnapshot(PlanningPortalGlobalState.SelectedDistributionLane);
    const distributionLanes = selectedDistributionLane?.join(",");
    
    const request = req.clone({
      setHeaders: {
        DistributionLanes: distributionLanes ?? ""
      },
    });

    return next.handle(request);
  }
}
